import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Target, Users, TrendingUp } from 'lucide-react';

const About = () => {
  return (
    <div className="min-h-screen">
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="heading-1 mb-6">Sydney-based. Outcome-led. Built for real environments.</h1>
          </motion.div>
        </div>
      </section>

      <section className="pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-12">
            <h2 className="heading-2 mb-4">Story</h2>
            <p className="body-large text-[var(--text-secondary)] mb-4">
              Ferntree builds and deploys AI-enabled solutions for security intelligence, operational visibility, and agricultural productivity. Our approach is simple: combine a modular platform with strong implementation—so intelligence changes what happens on site.
            </p>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-16">
            <h2 className="heading-2 mb-6">What we value</h2>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="p-6 bg-[var(--bg-card)] border border-[var(--border-light)] rounded-lg">
                <Target className="w-8 h-8 text-[var(--accent-primary)] mb-3" />
                <h3 className="font-semibold text-[var(--text-primary)] mb-2">Practical deployments</h3>
                <p className="text-sm text-[var(--text-secondary)]">Over theoretical demos</p>
              </div>
              <div className="p-6 bg-[var(--bg-card)] border border-[var(--border-light)] rounded-lg">
                <Users className="w-8 h-8 text-[var(--accent-primary)] mb-3" />
                <h3 className="font-semibold text-[var(--text-primary)] mb-2">Trust & governance</h3>
                <p className="text-sm text-[var(--text-secondary)]">Responsible delivery</p>
              </div>
              <div className="p-6 bg-[var(--bg-card)] border border-[var(--border-light)] rounded-lg">
                <TrendingUp className="w-8 h-8 text-[var(--accent-primary)] mb-3" />
                <h3 className="font-semibold text-[var(--text-primary)] mb-2">Continuous improvement</h3>
                <p className="text-sm text-[var(--text-secondary)]">Not one-time installs</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="py-20 px-6 bg-gradient-to-br from-[var(--accent-wash)] to-transparent">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
            <h2 className="heading-2 mb-6">If you're building for scale, start with a conversation.</h2>
            <Link to="/contact" className="btn-primary">Talk to an Expert</Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;